import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";

const {addClass, removeClass, get} = $dom

const groupSelector = '.js-rating-group'
const labelSelector = '.js-rating-label'

export default function () {
    const handleClickRating = e => {
        const ratingItems = e.target.closest(groupSelector)

        ratingItems.dataset.totalValue = e.target.dataset.itemValue

        const ratingLabel = get(labelSelector, ratingItems)

        if (ratingLabel) {
            ratingLabel.textContent = `${ratingItems.dataset.totalValue}/5`
        }
    }

    return new Component({
        name: 'rating',
        requiredTargets: groupSelector,
        onInit() {
            $events.delegate.on('click', groupSelector, handleClickRating)
        },
        onDestroy() {
            console.log('rating')
        },
    })

}